<template>
  <a
    href=""
    class="btn registration_next"
    :style="{ backgroundColor: color, color: textColor }"
    v-bind:class="{ outlined: mode === 'outline' }"
  >
    <slot></slot>
    <i v-if="loading" class="fa fa-spin fa-spinner" style="color: white"></i>
  </a>
</template>

<script>
export default {
  props: {
    textColor: { type: String, required: false, default: '' },
    color: { type: String, required: false, default: '' },
    mode: { type: String, required: false, default: '' },
    loading: { type: Boolean, required: false, default: false },
  },
}
</script>

<style scoped>
.registration_next {
  min-width: 380px;
  text-transform: uppercase;
  background-color: var(--primary_color);
  color: #fff;
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
}
@media only screen and (max-width: 600px) {
  .registration_next {
    min-width: 345px;
    width: 100%;
  }
}
</style>
